import { atom } from "recoil";
import { persistAtom } from "./persist";
import { TUserGroup, TUserRank } from "MVVM/@types";

export interface ISuggestedUserState {
  suggestedFollowers: Array<{
    _id: string;
    username: string;
    avatar: string;
    reason?: string;
    steam: {
      steamid?: string;
      personaname?: string;
    };
    userGroup: {
      type: TUserGroup;
    };
    rank?: TUserRank;
  }>;
  lastUpdated: number;
}

export interface ISuggestedUsersCacheState {
  [cacheKey: string]: ISuggestedUserState;
}

export const SuggestedUsersState = atom<ISuggestedUsersCacheState>({
  key: "SuggestedUsersState_v3",
  default: {},
  effects_UNSTABLE: [persistAtom],
});
